/* eslint-disable parog-web/no-glint-expect-error-directive */
import { array, concat } from '@ember/helper';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import t from 'ember-intl/helpers/t';
import journalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import MammographyDeclaredJournalEvent from 'parog-web/models/mammography-declared-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';

export default class MammographyEditionFormComponent extends journalEventBasedComponent {
  static override forcDisplayName = 'Mammographie ou IRM';
  static override fullComponentId = 'mammography-and-mri/edition-form';
  static override journalEventClass = MammographyDeclaredJournalEvent;

  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override journalEventProperties = [
    'occurredAt',
    'examType',
    'acrScore',
    'comments'
  ];

  override get toastMessage() {
    return this.session.patient
      ? {
          message: 'Votre déclaration a bien été prise en compte.',
          title: this.intl.t(
            `mammography-exam.type.${this.changeset.get('examType')}`
          )
        }
      : super.toastMessage;
  }

  override get validations() {
    return this.journalEventClass.validations(this.intl);
  }

  override retrieveModel() {
    const model = super.retrieveModel();
    model.occurredAt = model.occurredAt || new Date();
    model.examType = model.examType || 'mri';
    return model;
  }

  override save = async () => {
    await super.save();
    this.analytics.trackPatientMeasurement('mammography-and-mri');
  };

  <template>
    {{! @glint-expect-error }}
    <Provider @forcComponent={{this}} @title={{this.title}}>
      <:content as |Form|>
        <div class='field'>
          <Form.AlignedFieldsRadioGroup
            @propertyName='examType'
            @title='Pour quel examen souhaitez-vous déclarer un résultat ?'
            as |Group|
          >
            {{#each (array 'mri' 'mammography') as |type|}}
              <Group.FieldRadio
                @value={{type}}
                @label={{t (concat 'mammography-exam.type.' type)}}
              />
            {{/each}}
          </Form.AlignedFieldsRadioGroup>
        </div>

        <div class='field'>
          <Form.Date
            @labelName={{t
              (concat 'mammography-exam.date-label.' this.changeset.examType)
            }}
            @propertyName='occurredAt'
          />
        </div>

        <div class='field'>
          <Form.AlignedFieldsRadioGroup
            @propertyName='acrScore'
            @title='Score ACR'
            as |Group|
          >
            {{#each (array '0' '1' '2' '3' '4' '5') as |score|}}
              <Group.FieldRadio @value={{score}} @label={{score}} />
            {{/each}}
          </Form.AlignedFieldsRadioGroup>
        </div>
        <div class='field'>
          <Form.TextArea @labelName='Commentaires' @propertyName='comments' />
        </div>
      </:content>
    </Provider>
  </template>
}
